import React, {useCallback, useMemo} from 'react';

import EllipsisTextHint from '@pb/kit-component-ellipsis-text-hint';

import type {DictionaryItem} from 'src/openapi/admin/models/DictionaryItem';

type Props = {
    logId: string,
    actionTypeCode: string,
    actionTypeDictionary: DictionaryItem[],
    onLogClick: (logId: string) => void,
};

export const ChangeLogTypeCell = ({logId, actionTypeCode, actionTypeDictionary, onLogClick}: Props) => {
    const actionTypeDescription = useMemo(() => {
        const actionType = actionTypeDictionary.find(item => item.code === actionTypeCode);
        return actionType?.description || actionTypeCode;
    }, [actionTypeCode, actionTypeDictionary]);

    const onClick = useCallback(() => {
        onLogClick(logId);
    }, [logId, onLogClick]);

    return (
        <EllipsisTextHint title={actionTypeDescription}>
            <a onClick={onClick}><strong>{actionTypeDescription}</strong></a>
        </EllipsisTextHint>
    );
};
